import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/rabta logo.png";

export default function ConsumerLogin() {
    const navigate = useNavigate();

    // Step management: 1=mobile input, 2=OTP verification
    const [step, setStep] = useState(1);
    const [mobileNumber, setMobileNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // OTP timer
    const [otpTimer, setOtpTimer] = useState(0);
    const [canResendOtp, setCanResendOtp] = useState(true);

    const startOtpTimer = () => {
        setCanResendOtp(false);
        let timeLeft = 60;
        setOtpTimer(timeLeft);
        const timer = setInterval(() => {
            setOtpTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    setCanResendOtp(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    // Step 1: Send OTP
    const handleSendOtp = async (e) => {
        e.preventDefault();

        if (!/^[0-9]{10}$/.test(mobileNumber)) {
            setError("Please enter a valid 10-digit mobile number");
            return;
        }

        setError("");
        setIsSubmitting(true);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}consumer-auth/send-otp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ mobileNumber }),
            });

            const data = await res.json();

            if (data.status === "success") {
                setStep(2);
                startOtpTimer();
            } else {
                setError(data.message || "Failed to send OTP. Please try again.");
            }
        } catch (err) {
            console.error("Send OTP error:", err);
            setError("Something went wrong. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    // Step 2: Verify OTP
    const handleVerifyOtp = async () => {
        if (!otp || otp.length !== 6) {
            setError("Please enter a valid 6-digit OTP");
            return;
        }

        setError("");
        setIsSubmitting(true);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}consumer-auth/verify-otp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ mobileNumber, otp }),
            });

            const data = await res.json();

            if (data.status === "success") {
                // Store consumer data in localStorage
                localStorage.setItem("consumer", JSON.stringify({ mobileNumber, ...data.data }));

                // Navigate to cashbacks page
                navigate("/consumer/cashbacks");
            } else {
                setError(data.message || "Invalid OTP. Please try again.");
            }
        } catch (err) {
            console.error("Verify OTP error:", err);
            setError("Something went wrong. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    // Resend OTP
    const handleResendOtp = async () => {
        if (!canResendOtp) return;

        setError("");
        setIsSubmitting(true);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}consumer-auth/send-otp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ mobileNumber }),
            });

            const data = await res.json();

            if (data.status === "success") {
                startOtpTimer();
            } else {
                setError(data.message || "Failed to resend OTP");
            }
        } catch (err) {
            console.error("Resend OTP error:", err);
            setError("Failed to resend OTP");
        } finally {
            setIsSubmitting(false);
        }
    };

    // Step 1: Mobile Number Input
    if (step === 1) {
        return (
            <div className="main-bg">
                <div className="form-container-ret">
                    <div className="wrapper-form">
                        <div style={{ textAlign: "center" }}>
                            <img src={Logo} alt="logo" className="logo-main" />
                        </div>

                        <p style={{ textAlign: "center", marginBottom: "20px", color: "#333" }}>
                            Thanks for participating! Stay tuned as we announce the winners.
                            {/* Log in to claim any pending cashbacks. */}
                        </p>

                        {/* <form onSubmit={handleSendOtp}>
                            <input
                                type="tel"
                                name="mobile"
                                placeholder="Mobile Number*"
                                value={mobileNumber}
                                onChange={(e) => setMobileNumber(e.target.value.replace(/[^0-9]/g, ""))}
                                maxLength={10}
                            />

                            {error && <p className="error">{error}</p>}

                            <button type="submit" className="verifyBtn" disabled={isSubmitting}>
                                {isSubmitting ? "Sending OTP..." : "Send OTP"}
                            </button>
                        </form> */}
                    </div>
                </div>
            </div>
        );
    }

    // Step 2: OTP Verification
    return (
        <div className="main-bg">
            <div className="form-container-ret success-screen">
                <img className="logo-main" src={Logo} alt="logo" />
                <div className="otp-block">
                    <h2>Verify your number</h2>
                    <input
                        type="text"
                        name="otp"
                        placeholder="Enter 6-digit OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ""))}
                        maxLength="6"
                    />

                    {otpTimer > 0 && <p>OTP sent successfully to your mobile number</p>}

                    {error && <p className="error">{error}</p>}

                    {otpTimer > 0 && (
                        <button
                            onClick={handleVerifyOtp}
                            disabled={isSubmitting}
                            className="verifyBtn"
                            style={{ marginTop: "20px" }}
                        >
                            {isSubmitting ? "Verifying..." : "Confirm"}
                        </button>
                    )}

                    <div className="resend-otp-section">
                        {otpTimer > 0 ? (
                            <p className="timer-text">
                                Resend OTP in <span className="timer-count">{otpTimer}s</span>
                            </p>
                        ) : (
                            <button
                                className="resend-btn btn-common"
                                onClick={handleResendOtp}
                                disabled={isSubmitting || !canResendOtp}
                            >
                                {isSubmitting ? "Resending..." : "Resend OTP"}
                            </button>
                        )}
                    </div>

                    <button
                        style={{ marginTop: "10px" }}
                        className="back-btn"
                        onClick={() => {
                            setStep(1);
                            setOtp("");
                            setError("");
                            setOtpTimer(0);
                            setCanResendOtp(true);
                        }}
                        disabled={isSubmitting}
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
}
